"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useScrollPosition = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
var useScrollPosition = exports.useScrollPosition = function useScrollPosition(triggerChange) {
  var ref = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isScrolling = _useState2[0],
    setIsScrolling = _useState2[1];
  var onScroll = function onScroll() {
    var element = ref.current;
    if (element.scrollHeight - element.clientHeight < element.scrollTop + 10) {
      setIsScrolling(false);
    } else {
      setIsScrolling(true);
    }
  };
  var scrollToBottom = function scrollToBottom(element) {
    setIsScrolling(function (prev) {
      if (!prev) {
        element.scrollTop = element.scrollHeight - element.clientHeight;
      }
      return prev;
    });
  };
  var jumpToLatest = function jumpToLatest(event) {
    event && event.preventDefault();
    setIsScrolling(false);
    scrollToBottom(ref.current);
  };
  (0, _react.useEffect)(function () {
    if (ref.current) {
      scrollToBottom(ref.current);
      var observer = new window.MutationObserver(function () {
        return scrollToBottom(ref.current);
      });
      observer.observe(ref.current, {
        childList: true
      });
      ref.current.addEventListener('touchmove', onScroll, false);
      ref.current.addEventListener('mousewheel', onScroll, false);
    }
    return function () {
      if (ref.current) {
        ref.current.removeEventListener('touchmove', onScroll, false);
        ref.current.removeEventListener('mousewheel', onScroll, false);
      }
    };
  }, [ref]);
  (0, _react.useEffect)(function () {
    jumpToLatest();
  }, [triggerChange]);
  return [ref, isScrolling, jumpToLatest];
};